import { Action } from '@ngrx/store';

export enum EDisplayIaChatbotActions {
  DisplayIaChatbot = '[DISPLAY_IA_CHATBOT] Display IA chatboot'
}

export class DisplayIaChatbot implements Action {
  public readonly type = EDisplayIaChatbotActions.DisplayIaChatbot;
  constructor(public payload: string|null) {}
}

export type DisplayIaChatbotActions = DisplayIaChatbot;
